import React, { useEffect, useState } from "react";
import Menubar from "../Menubar";
import { Container, Row, Col, Table } from "react-bootstrap";import { MdOutlinePictureAsPdf } from "react-icons/md";import Select from 'react-select';
import { store } from "../../App"; import { AiFillFileExcel, AiOutlineSearch } from "react-icons/ai"; import { exportToExcel, datetime, formatNumberIndianWithDecimal, generatePdf, commonSelectProps } from "../utils/commonFunctions"; import KpiService from "../../Services/KpiService"; import AlertModal from "../Alert/AlertModal"; import useAlert from "../Alert/useAlert"; import { Field, FormikProvider, Form, useFormik } from "formik"; import MasterService from "../../Services/MasterService";


export default function TargetsVsachievementsPercentChangeReport() {
  const { showAlert, alertData,showAlertMessage, closeAlert } = useAlert(); const [currentdate, setcurrentdate] = useState(""); const [currenttime, setcurrenttime] = useState(""); const [data, setData] = useState([]); const[subTableData,setSubTableData]=useState([]);const [Deptlist, setDeptlist] = useState([]); const [distlist, setDistrictList] = useState(); const [Yearlist, setYearlist] = useState();const [selectedperiodic, setselectedperiodic] = useState(); const [Periodicitylist, setPeriodicitylist] = useState(); const [searchText, setSearch] = useState("");
 const [SubTableEnb,setSubTableEnb]=useState(false); const [SubDistTableEnb,setSubDistTableEnb]=useState(false); const[maintablenb,setmaintablenb]=useState(true); const [selecteddist,setselecteddist]=useState(""); const [year,setYear] = useState(""); const [yearList,setYearList] = useState([]);
 let ulbdeptlist=JSON.parse(localStorage.getItem("ulbdeptlist") || "[]");  
  let username = localStorage.getItem("username"); let deptId = localStorage.getItem("deptid"); let district = localStorage.getItem("districtid");
  let roleid = localStorage.getItem("catid");

  const formik = useFormik({ initialValues: { year: "", department_id:"", periodic_id:"", district_id:"",ind_type:"" }, });

  useEffect(() => {
    datetime(setcurrentdate, setcurrenttime);
        let params = { userId: username }
       

          MasterService.getAllDepts(params).then((res) => { if (res.data) { setDeptlist([ { dept_id: "0", dept_name: "All" }, ...(res.data?.SDESC ?? []) ]); } });
        
           MasterService.getDistricts().then((res17) => { if (res17.data) { setDistrictList(res17.data); } });
              if(["113","119"].includes(roleid)){setselecteddist(localStorage.getItem("districtname"))}
if(["113","114","115","111"].includes(roleid)){formik.setFieldValue("department_id",deptId); perioicitylist(deptId); }
if(["113","114","115"].includes(roleid)){formik.setFieldValue("department_id",deptId); formik.setFieldValue("district_id",district); }
if(["119"].includes(roleid)){ formik.setFieldValue("district_id",district); }
}, []);


const periodicityMap = { all: { label: "All", value: "0" }};
const perioicitylist = (dept) => {
  formik.setFieldValue("periodic_id","");
  if(!dept){ setPeriodicitylist([]); return; }
    if (dept === "0") { const allOptions = Object.keys(periodicityMap).map((key) => ({ label: periodicityMap[key].label, value: periodicityMap[key].value, })); setPeriodicitylist(allOptions); return; }
  else { let paramss = { userId: username, deptId: dept };
    KpiService.periodicityStatus(paramss).then((res) => {
      if (res.data) { if (res.data.SCODE === "01") {
          const apiData = res.data.SDESC[0];  const options = [periodicityMap.all, ...Object.keys(periodicityMap) .filter((key) => key !== "all" && apiData[key] > 0) .map((key) => periodicityMap[key]), ];
          setPeriodicitylist(options);}else { setPeriodicitylist([]); showAlertMessage(res.data.SDESC, "warning"); }
      }
    });
}};
const indicatortypeOptions = [
  { value: "0", label: "All" },
  { value: "3", label: "SDG" },
  { value: "4", label: "Economic" },
];
  const YearData = (val) => {
    setData([]); formik.setFieldValue("year","");  formik.setFieldValue("ind_type",""); setYearlist([]); if (!val) { return; }
    if(val === "0"){ MasterService.getfinyears().then((achievvalueres) => { if (achievvalueres.data) { setYearList(achievvalueres.data); } }); }
          else{ let params = { userId: username, periodicityId:val }; KpiService.KpiperiodicYears(params).then((res20) => { let res = res20.data.SDESC.yearsList; if (res20.data) {setYearList(res); } }) }

    
    
  }
   const getData = (id) => {
    if (!formik.values.year ||!id|| !formik.values.department_id || !formik.values.periodic_id) {
      setSubTableData([]);
      setData([]);
      setSubTableEnb(false);
      return;
    }
    setselectedperiodic(parseInt(formik.values.periodic_id));
    let params = { "year":year,"indPhaseId":id,
    "periodicityId":"0",
    "deptId":formik.values.department_id,
    "userId":username,
    buttonType:"main",
districtId:"0", 
};
    
    store.dispatch({ type: "SHOW_SPINNER" });
    KpiService.targetsAchvmtsPercentVariationReport(params)
      .then((res) => {
          setSubTableEnb(false);
          setSubDistTableEnb(false);
          setmaintablenb(true);
        if (res.data && res.data.SCODE == "01") {
          setData(res.data.SDESC);
        } else {
          setData([]);
        }
      }).catch(() => { showAlertMessage("Failed to fetch data. Please try again.", "warning"); }).finally(() => { store.dispatch({ type: "HIDE_SPINNER" }); });
  };
  
  const filteredData = searchText.length > 0 && data?.length ? data.filter((item) => { return ( item && Object.keys(item).some((key) => { const value = item[key]; return value !== null && value.toString().toLowerCase().includes(searchText.toLowerCase()); }) ); }) : data;

      

const hodenb=(id)=>{ perioicitylist(id); formik.setFieldValue("periodic_id",""); formik.setFieldValue("year",""); formik.setFieldValue("ind_type",""); setData([]); }
 
  const headerStyle = { backgroundColor: "#4e835c", color: "white", padding: "5px", border: "1px solid white" };

const getPreviousFinancialYear = (fy) => { if (!fy || !fy.includes("-")) return ""; const [start, end] = fy.split("-").map(Number); return `${start - 1}-${(end - 1).toString().padStart(2, "0")}`; };





  return (
    <>
      <Menubar />
      <Container fluid style={{ width: "96%" }}> <div className="sa-title"> <h2>Targets , Achievements <span> Percentage Variation Report  </span> </h2> </div> </Container>
      <Container fluid style={{ width: "96%" }} className="outer-page-content-container">
        <FormikProvider value={formik}>
          <Form onSubmit={formik.handleSubmit}>
            <div className="py-2 px-4 mb-3">
              <Row>
                 <Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3}> <label htmlFor="department_id" className="mb-1 fw-bold"> {" "} HOD Name </label> 
                 <Select {...commonSelectProps({ name: "department_id", options: Deptlist, value: formik.values.department_id, optionValueKey: "dept_id", optionLabelKey: "dept_name", formik, isDisabled: ["113","114","115"].includes(roleid), extraOnChange: (option) => { hodenb(option ? option.dept_id : ""); } })} /> </Col>
                 {["113","119"].includes(roleid) &&
                                   <Col xs={12} sm={12} lg={3} md={3} xl={3} xxl={3} className='district-select'> <label className="mb-1 fw-bold">District</label> <Select {...commonSelectProps({ name: "district_id", options: distlist, value: formik.values.district_id, optionValueKey: "id", optionLabelKey: "value", formik, isDisabled: true, extraOnChange: (option) => { } })} /> </Col>}
                <Col xs={12} sm={12} lg={3} md={3} xl={3} xxl={3} className='mandal-select'> <label className="mb-1 fw-bold"> Periodicity </label> 
                <span style={{ color: "red" }}> *</span>
                <Select {...commonSelectProps({ name: "periodic_id", options: Periodicitylist, value: formik.values.periodic_id, optionValueKey: "value", optionLabelKey: "label", formik, isDisabled: false, extraOnChange: (option) => { YearData(option ? option.value : ""); } })} /> </Col>
            <Col xs={12} sm={12} lg={3} md={3} xl={3} xxl={3}>
                  <label className="mb-1 fw-bold"> Financial Year </label> <span style={{ color: "red" }}> *</span><Select {...commonSelectProps({ name: "year", options: yearList, value: formik.values.year, optionValueKey: "id", optionLabelKey: "value", formik, isDisabled: false, extraOnChange: (option) => { setYear(option? option.id:"") } })} />   

                </Col>
                  <Col xs={12} sm={12} lg={3} md={3} xl={3} xxl={3}>
                  <label className="mb-1 fw-bold"> Indicator Type </label> <span style={{ color: "red" }}> *</span>
                   <Select {...commonSelectProps({ name: "ind_type", options: indicatortypeOptions, value: formik.values.ind_type, optionValueKey: "value", optionLabelKey: "label", formik, isDisabled: false, extraOnChange: (option) => { getData(option? option.value:""); } })} />   
              
                </Col>
              </Row>
            </div>
          </Form>
        </FormikProvider>

        {maintablenb && <>
        <Row>
          <Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3} className=" mb-3">
            
            <div style={{ display: "flex", alignItems: "center", border: "1px solid #ddd", borderRadius: "20px", boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)", transition: "all 0.3s ease-in-out", backgroundColor: "#fff", padding: "5px 10px", width: "150px", minWidth: "150px" }} id="search-container"><AiOutlineSearch className="me-2" style={{ fontSize: "1.2rem", color: "#888", visibility: "visible" }} />
              <input type="text" placeholder="Search" value={searchText} onChange={(e) => setSearch(e.target.value)} 
              onFocus={(e) => { const parent = e.currentTarget.parentElement; parent.style.boxShadow = "0 6px 12px rgba(0, 0, 0, 0.2)"; parent.style.border = "1px solid #353935"; parent.style.width = "100%"; }} onBlur={(e) => { const parent = e.currentTarget.parentElement; parent.style.boxShadow = "0 4px 8px rgba(0, 0, 0, 0.1)"; parent.style.border = "1px solid #ddd"; parent.style.width = "150px"; }} style={{ flex: "1", border: "none", outline: "none", fontSize: "1rem", color: "#333", backgroundColor: "transparent", transition: "color 0.3s ease", minWidth: "0" }} />
            </div>
          </Col>
          <Col className="mb-2">
           <button  onClick={() => generatePdf("#my-table", "Targets Vs Achievements Percentage Variation Report", 14)} className="btn btn-danger btn-sm mx-2 pdf-btn"
           style={{ float: "right", marginLeft: "3px" }} > PDF <MdOutlinePictureAsPdf /> </button>
           <button className="btn mx-2 excel-btn" size="sm" style={{ float: "right", color: "#ffffff", marginLeft: "3px" }} 
           onClick={() => exportToExcel("my-table", "TargetsVsAchievementsPercentageVariationReport")}> Excel <AiFillFileExcel style={{ fontSize: "18px" }} /> </button>
         
          </Col>
        </Row>

        <div style={{ textAlign: "center", backgroundColor: "#d4e3d8" }} className="rounded-1 border py-1"> <span className="style"> Targets Vs Achievements Percentage Variation Report</span> <div className="text-end style-1"> Report On : {currentdate} {currenttime} </div> </div>
        <div id="table-scroll" className="table-scroll">
          <div className="table-wrap">
            <Table bordered id="my-table" className="custom-table table-responsive  table table-bordered sticky-table">
        
           <thead>
                <tr className="text-center only-export"> <th colSpan={14} style={{ backgroundColor: "#d4e3d8", textAlign: "center" }}> Targets Vs Achievements Percentage Variation Report </th> </tr>

  <tr className="text-center">
    <th style={headerStyle}  className="sticky-col sticky-sno"rowSpan={![8,2,3,0].includes(selectedperiodic) ? 2:1}>Sl.No.</th>
    <th className="sticky-col sticky-KPIHOD indicator-column" style={headerStyle} rowSpan={![8,2,3,0].includes(selectedperiodic) ? 2:1} >HOD Name</th> <th style={{ ...headerStyle, }} rowSpan={![8, 2, 3, 0].includes(selectedperiodic) ? 2 : 1} className={(formik.values.year !=="" && data) ?`sticky-col sticky-KPIIND indicator-column`:""}> Indicator Name </th> <th style={headerStyle} rowSpan={![8,2,3,0].includes(selectedperiodic) ? 2:1} className={(formik.values.year !=="" && data) ?`sticky-col sticky-KPIvalueUNIT`:""}>Unit</th> <th style={headerStyle} rowSpan={![8,2,3,0].includes(selectedperiodic) ? 2:1} className={(formik.values.year !=="" && data) ?`sticky-col sticky-KPIvaluePERIODIC`:""}>Periodicity</th> <th style={headerStyle} rowSpan={![8,2,3,0].includes(selectedperiodic) ? 2:1} className={(formik.values.year !=="" && data) ?`sticky-col sticky-KPIvalueNature`:""}>Positive / <br/>Negative</th> <th style={headerStyle} rowSpan={![8,2,3,0].includes(selectedperiodic) ? 2:1} className={(formik.values.year !=="" && data) ?`sticky-col sticky-KPIvalueEntry`:""}>Entry Level</th> 
     <th style={headerStyle}>Indicator <br/>Type </th>
   <th style={headerStyle}>Goal <br/>Name  </th><th style={headerStyle}>Broad Sector <br/>Name   </th> <th style={headerStyle}>Sub Sector <br/>Name   </th><th style={headerStyle} rowSpan={![8,2,3,0].includes(selectedperiodic) ? 2:1}>Targets <br/>{formik.values.year}</th>
      <th style={headerStyle} colSpan={selectedperiodic == 6 ? 13 : selectedperiodic == 7 ? 5: selectedperiodic == 5 ? 3: 1} rowSpan={1}>Achievements <br/>{getPreviousFinancialYear(formik.values.year)}
 

</th>
   <th style={headerStyle}>Variation <br/>Percentage</th>
  

  </tr>

  {(selectedperiodic == 6 || selectedperiodic == 7 || selectedperiodic == 5) && (
    <tr className="text-center">
    

    {selectedperiodic === 6 && (
  <>
   {[ "April", "May", "June", "July", "August", "September", "October", "November", "December", "January", "February", "March" ].map((month) => ( <th key={month} style={headerStyle}>{month}</th> ))} <th style={headerStyle}>Total</th>
  </>
)}

{selectedperiodic == 7 &&<> {["Q1", "Q2", "Q3", "Q4"].map((q) => ( <th key={q} style={headerStyle}>{q}</th> ))}
    <th style={headerStyle}>Total</th>
</>
    }

      {selectedperiodic == 5 &&<>
        {["HY1", "HY2"].map((h) => ( <th key={h} style={headerStyle}>{h}</th> ))} <th style={headerStyle}>Total</th>
</> }</tr>
  )}
</thead>

<tbody>
  {filteredData?.length === 0 || filteredData === undefined ? (
    <tr>
      <td className="text-center" colSpan={ selectedperiodic == 6 ? 21 : selectedperiodic == 7 ? 13 : selectedperiodic == 5 ? 11 : 9 } > <b style={{ color: "red" }}>Details Not Found</b> </td>
    </tr>
  ) : (
    (() => { const grouped = {}; filteredData.forEach((item) => { const key = item.dept_id; if (!grouped[key]) grouped[key] = []; grouped[key].push(item); });

      let slno = 0;

      return Object.entries(grouped).flatMap(([deptId, rows]) => {
         const hasMandal = rows?.some( (r) => r.enrty_type?.toLowerCase() === "mandal" );
        const hasDistMandal = rows?.some( (item) => ["mandal", "district"].includes(item.enrty_type?.toLowerCase()) );
        const canClick = ["119", "113"].includes(roleid) ? hasMandal : ["114", "116","115"].includes(roleid) ? hasDistMandal : true;        
        return rows.map((detail, i) => {
          slno += 1;
          return (
            <tr key={`${deptId}-${i}`}>
              <td
                className="sticky-col sticky-sno"
                style={{ textAlign: "center" }}
              >
                {slno}
              </td>
{i === 0 && ( 
  <td className="sticky-col sticky-KPIHOD indicator-column" style={{ textAlign: "left", verticalAlign: "top", color: "black", }} rowSpan={rows.length}  > {detail.dept_name || ""} </td> )} 
<td style={{ textAlign: "left" }} className={(formik.values.year !=="" && data) ? `sticky-col sticky-KPIIND indicator-column`:""}> {detail.indicator_name || ""} </td> 
<td  style={{ minWidth: "70px", maxWidth: "70px", width: "auto", wordWrap: "break-word", overflowWrap: "break-word", whiteSpace: "normal", textAlign:"left" }} className={(formik.values.year !=="" && data) ? `sticky-col sticky-KPIvalueUNIT`:""}>{detail.unit_name || ""}</td>
              <td style={{ textAlign: "left" }} className={(formik.values.year !=="" && data) ? `sticky-col sticky-KPIvaluePERIODIC`:""}> {detail.periodic_name || ""} </td> <td style={{ textAlign: "left" }}  className={(formik.values.year !=="" && data) ? `sticky-col sticky-KPIvalueNature`:""}> {detail.indicator_nature || ""} </td> <td style={{ textAlign: "left" }} className={(formik.values.year !=="" && data) ? `sticky-col sticky-KPIvalueEntry`:""}>{detail.enrty_type || ""}</td> 
              <td style={{ textAlign: "left" }}> {detail.ind_phase_name || "-"} </td>
<td style={{ textAlign: "left" ,whiteSpace: "normal", wordWrap: "break-word"}}> {detail.ind_goal_name||"-"} </td>
<td style={{ textAlign: "left" }}> {detail.ind_broad_sector_name || "-"} </td>
<td style={{ textAlign: "left" }}> {detail.ind_sub_sector_name || "-"} </td>

              <td style={{ textAlign: "right" }}> {detail.unit_cat_id === 1 ? formatNumberIndianWithDecimal(detail.targets_2025) : detail.targets_2025} </td>
              {selectedperiodic === 6 && ( <> {[ "apr", "may", "jun", "jul", "aug", "sep", "oct", "nov", "dec", "jan", "feb", "mar", ].map((m) => ( <td key={m} style={{ textAlign: "right" }}> {detail.unit_cat_id === 1 ? formatNumberIndianWithDecimal( detail[`m_indicator_value_${m}`] ) : detail[`m_indicator_value_${m}`] || ""} </td> ))} <td style={{ textAlign: "right" }}> {detail.unit_cat_id === 1 ? formatNumberIndianWithDecimal( detail.indicator_value_total ) : detail.indicator_value_total} </td> </> )}

              {selectedperiodic === 7 && ( <> {["q1", "q2", "q3", "q4"].map((q) => ( <td key={q} style={{ textAlign: "right" }}> {detail.unit_cat_id === 1 ? formatNumberIndianWithDecimal( detail[`m_indicator_value_${q}`] ) : detail[`m_indicator_value_${q}`] || ""} </td> ))} <td style={{ textAlign: "right" }}> {detail.unit_cat_id === 1 ? formatNumberIndianWithDecimal( detail.indicator_value_total ) : detail.indicator_value_total} </td> </> )}

              {selectedperiodic === 5 && ( <> {["hy1", "hy2"].map((h) => ( <td key={h} style={{ textAlign: "right" }}> {detail[`m_indicator_value_${h}`] } </td> ))} <td style={{ textAlign: "right" }}> {detail.unit_cat_id === 1 ? formatNumberIndianWithDecimal( detail.indicator_value_total ) : detail.indicator_value_total} </td> </> )}

              {[0].includes(selectedperiodic) && ( <td style={{ textAlign: "right" }}> {detail.unit_cat_id === 1 ? formatNumberIndianWithDecimal(detail.indicator_value) : detail.indicator_value } </td> )}

              {[8, 2, 3].includes(selectedperiodic) && ( <td style={{ textAlign: "right" }}> {detail.unit_cat_id === 1 ? formatNumberIndianWithDecimal( detail.indicator_value_total ) : detail.indicator_value_total} </td> )}
<td style={{ textAlign: "right" }}> {detail.var_per || "-"} </td>

            </tr>
          );
        });
      });
    })()
  )}
</tbody>


            </Table>
          </div>
        </div> </>}


 

        
      </Container>
      <AlertModal show={showAlert} titleText={alertData.titleText} alertText={alertData.alertText} onClose={closeAlert} />
    </>
  );
}



